// extracted by css-extract-rspack-plugin
export default {"title":"nypFN7Na_8jO1G4Y"};